module.exports = __webpack_public_path__ + "static/media/TM_logo_black.4807c299.png";